import mirrorKeys from 'utils/mirror-keys'

export const eligibilityCriteria = [
  { label: 'Academics', value: 'academics' },
  { label: 'Activity', value: 'activity' },
  { label: 'Affiliation', value: 'affiliation' },
  { label: 'Age', value: 'age' },
  { label: 'Application Restriction', value: 'applicationRestriction' },
  { label: 'Armed Services', value: 'armedServices' },
  { label: 'Citizenship Status', value: 'citizenshipStatuses' },
  { label: 'College Attendance', value: 'collegeAttendanceCriteria' },
  {
    label: 'College Readiness Program',
    value: 'collegeReadinessProgramParticipation',
  },
  { label: 'Condition', value: 'condition' },
  { label: 'Current Grade Level', value: 'currentGradeLevel' },
  { label: 'Profession', value: 'profession' },
  { label: 'Current School', value: 'currentSchool' },
  { label: 'Demographics', value: 'demographics' },
  { label: 'Fields of Study', value: 'fieldsOfStudy' },
  { label: 'Financial Information', value: 'financialInformation' },
  { label: 'Graduation Status', value: 'graduationStatuses' },
  { label: 'Interests', value: 'interests' },
  { label: 'Locations', value: 'locations' },
  { label: 'Miscellaneous', value: 'miscellaneous' },
  { label: 'Situation', value: 'situation' },
  { label: 'Seeking Degree', value: 'degreeSeeking' },
];

export const criterias = [
  { label: 'Citizenship Status', value: 'citizenshipEligibilities' },
  { label: 'Graduation Status', value: 'graduationStatuses' },
  { label: 'Current Grade Level', value: 'currentGradeLevels' },
  { label: 'Seeking Degree', value: 'degreeSoughts' },
];

export const races = [
  'American Indian or Alaska Native',
  'Asian',
  'Black or African American',
  'Native Hawaiian or Other Pacific Islander',
  'White',
];

export const applicationType = [
  { value: 'Online', label: 'Online' },
  { value: 'PDF/Paper', label: 'PDF/Paper' },
];

export const filterDates = [
  { value: 'openDate', label: 'Open Date' },
  { value: 'closeDate', label: 'Close Date' },
];

export const filterGenders = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
];

export const stateList = [
  { label: 'Alabama', value: 'AL' },
  { label: 'Alaska', value: 'AK' },
  { label: 'American Samoa', value: 'AS' },
  { label: 'Arkansas', value: 'AR' },
  { label: 'Arizona', value: 'AZ' },
  { label: 'California', value: 'CA' },
  { label: 'Colorado', value: 'CO' },
  { label: 'Connecticut', value: 'CT' },
  { label: 'Delaware', value: 'DE' },
  { label: 'District of Columbia', value: 'DC' },
  { label: 'Florida', value: 'FL' },
  { label: 'Micronesia', value: 'FM' },
  { label: 'Georgia', value: 'GA' },
  { label: 'Guam', value: 'GU' },
  { label: 'Hawaii', value: 'HI' },
  { label: 'Idaho', value: 'ID' },
  { label: 'Illinois', value: 'IL' },
  { label: 'Indiana', value: 'IN' },
  { label: 'Iowa', value: 'IA' },
  { label: 'Kansas', value: 'KS' },
  { label: 'Kentucky', value: 'KY' },
  { label: 'Louisiana', value: 'LA' },
  { label: 'Maine', value: 'ME' },
  { label: 'Marshall Islands', value: 'MH' },
  { label: 'Maryland', value: 'MD' },
  { label: 'Massachusetts', value: 'MA' },
  { label: 'Michigan', value: 'MI' },
  { label: 'Minnesota', value: 'MN' },
  { label: 'Mississippi', value: 'MS' },
  { label: 'Missouri', value: 'MO' },
  { label: 'Montana', value: 'MT' },
  { label: 'Nebraska', value: 'NE' },
  { label: 'Nevada', value: 'NV' },
  { label: 'New Hampshire', value: 'NH' },
  { label: 'New Jersey', value: 'NJ' },
  { label: 'New Mexico', value: 'NM' },
  { label: 'New York', value: 'NY' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota', value: 'ND' },
  { label: 'Northern Mariana Islands', value: 'MP' },
  { label: 'Ohio', value: 'OH' },
  { label: 'Oklahoma', value: 'OK' },
  { label: 'Oregon', value: 'OR' },
  { label: 'Pennsylvania', value: 'PA' },
  { label: 'Puerto Rico', value: 'PR' },
  { label: 'Palau', value: 'PW' },
  { label: 'Rhode Island', value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota', value: 'SD' },
  { label: 'Tennessee', value: 'TN' },
  { label: 'Texas', value: 'TX' },
  { label: 'Utah', value: 'UT' },
  { label: 'U.S. Armed Forces – Americas', value: 'AA' },
  { label: 'U.S. Armed Forces – Europe', value: 'AE' },
  { label: 'U.S. Armed Forces – Pacific', value: 'AP' },
  { label: 'Vermont', value: 'VT' },
  { label: 'Virgin Islands', value: 'VI' },
  { label: 'Virginia', value: 'VA' },
  { label: 'Washington', value: 'WA' },
  { label: 'West Virginia', value: 'WV' },
  { label: 'Wisconsin', value: 'WI' },
  { label: 'Wyoming', value: 'WY' },
  { label: 'Canada - Alberta', value: 'CA-AB' },
  { label: 'Canada - British Columbia', value: 'CA-BC' },
  { label: 'Canada - Manitoba', value: 'CA-MB' },
  { label: 'Canada - New Brunswick', value: 'CA-NB' },
  { label: 'Canada - Newfoundland and Labrador', value: 'CA-NL' },
  { label: 'Canada - Northwest Territories', value: 'CA-NT' },
  { label: 'Canada - Nova Scotia', value: 'CA-NS' },
  { label: 'Canada - Nunavut', value: 'CA-NU' },
  { label: 'Canada - Ontario', value: 'CA-ON' },
  { label: 'Canada - Prince Edward Island', value: 'CA-PE' },
  { label: 'Canada - Quebec', value: 'CA-QC' },
  { label: 'Canada - Saskatchewan', value: 'CA-SK' },
  { label: 'Canada - Yukon', value: 'CA-YT' },
  { label: 'Mexico - Aguascalientes', value: 'MX-AG' },
  { label: 'Mexico - Baja California', value: 'MX-BN' },
  { label: 'Mexico - Baja California Sur', value: 'MX-BS' },
  { label: 'Mexico - Campeche', value: 'MX-CM' },
  { label: 'Mexico - Chiapas', value: 'MX-CP' },
  { label: 'Mexico - Chihuahua', value: 'MX-CH' },
  { label: 'Mexico - Coahuila', value: 'MX-CA' },
  { label: 'Mexico - Colima', value: 'MX-CL' },
  { label: 'Mexico - Mexico City', value: 'MX-DF' },
  { label: 'Mexico - Durango', value: 'MX-DU' },
  { label: 'Mexico - Guanajuato', value: 'MX-GT' },
  { label: 'Mexico - Guerrero', value: 'MX-GR' },
  { label: 'Mexico - Hidalgo', value: 'MX-HI' },
  { label: 'Mexico - Jalisco', value: 'MX-JA' },
  { label: 'Mexico - México', value: 'MX-MX' },
  { label: 'Mexico - Michoacán', value: 'MX-MC' },
  { label: 'Mexico - Morelos', value: 'MX-MR' },
  { label: 'Mexico - Nayarit', value: 'MX-NA' },
  { label: 'Mexico - Nuevo León', value: 'MX-NL' },
  { label: 'Mexico - Oaxaca', value: 'MX-OA' },
  { label: 'Mexico - Puebla', value: 'MX-PU' },
  { label: 'Mexico - Querétaro', value: 'MX-QE' },
  { label: 'Mexico - Quintana Roo', value: 'MX-QR' },
  { label: 'Mexico - San Luis Potosí', value: 'MX-SL' },
  { label: 'Mexico - Sinaloa', value: 'MX-SI' },
  { label: 'Mexico - Sonora', value: 'MX-SO' },
  { label: 'Mexico - Tabasco', value: 'MX-TB' },
  { label: 'Mexico - Tamaulipas', value: 'MX-TM' },
  { label: 'Mexico - Tlaxcala', value: 'MX-TL' },
  { label: 'Mexico - Veracruz', value: 'MX-VE' },
  { label: 'Mexico - Yucatán', value: 'MX-YU' },
  { label: 'Mexico - Zacatecas', value: 'MX-ZA' },
  { label: 'Other', value: 'Other' },
];

export const criteriaOptions = [
  { value: 'organizationType', label: 'Organization Type' },
  { value: 'yearFirstScholarship', label: 'Scholarship Program Established' },
  { value: 'totalDollarAmount', label: 'Total Award Amount'},
  { value: 'totalNumberStudents', label: 'Annual Awards Given' },
  { value: 'awardRange', label: 'Award Range' },
  { value: 'renewable', label: 'Renewable' },
  { value: 'needBased', label: 'Need Based' },
  { value: 'degreeBeingSought', label: 'Seeking Degree' },
  { value: 'age', label: 'Age' },
  { value: 'totalOverhead', label: 'Organization Total Overhead' },
  { value: 'totalPayroll', label: 'Organization Total Payroll' },
  { value: 'staffCount', label: 'Program Staff Count' },
  { value: 'meritBased', label: 'Merit Based' },
  { value: 'financialInformation', label: 'Financial Information' },
  { value: 'graduationStatus', label: 'Graduation Status' },
  { value: 'interests', label: 'Interests' },
  { value: 'miscellaneous', label: 'Miscellaneous' },
  { value: 'professions', label: 'Professions' },
  { value: 'situation', label: 'Situation' },
  { value: 'nspaMember', label: 'NSPA Member' },
  { value: 'numPrograms', label: 'Number of Programs' },
  { value: 'unforeseenEvents', label: 'Unforeseen Events' },
  { value: 'totalAwardAmount', label: 'Annual Program Award' },
];

export const criteriaOptionsLeft = [
  { value: 'annualAwardAmount', label: 'Annual Award Amount' },
  { value: 'numberOfPrograms', label: 'Number Of Programs' },
  { value: 'organizationType', label: 'Organization Type' },
  { value: 'proximity', label: 'Proximity Only' },
  { value: 'memberAnnualAwardAmount', label: 'Organization Type & Annual Award Amount' },
  { value: 'memberNumberOfPrograms', label: 'Organization Type & Number of Programs' },
  { value: 'memberProximity', label: 'Organization Type & Proximity' },
  { value: 'proximityAnnualAward', label: 'Proximity & Annual Award Amount' },
  { value: 'proximityNumberOfPrograms', label: 'Proximity & Number of Programs' },
];

export const elegiOptions = [
  { value: 'academics', label: 'Academics' },
  { value: 'age', label: 'Age' },
  { value: 'citizenshipStatuses', label: 'Citizenship' },
  { value: 'currentGradeLevel', label: 'Current Grade Level' },
  { value: 'degreeBeingSought', label: 'Seeking Degree' },
  { value: 'financialInformation', label: 'Financial Information' },
  { value: 'activity', label: 'Activities' },
  { value: 'affiliations', label: 'Affiliations' },
  { value: 'applicationRestriction', label: 'Application Restrictions' },
  { value: 'armedServices', label: 'Armed Services' },
  { value: 'collegeReadiness', label: 'College Readiness Programs' },
  { value: 'condition', label: 'Condition' },
  { value: 'demographics', label: 'Demographics' },
  { value: 'fieldsOfStudy', label: 'Fields Of Study' },
  { value: 'graduationStatus', label: 'Graduation Status' },
  { value: 'interests', label: 'Interests' },
  { value: 'miscellaneous', label: 'Miscellaneous' },
  { value: 'professions', label: 'Professions' },
  { value: 'situation', label: 'Situation' },
];

export const enrollmentStatusList = [
  { value: 'Full-Time or Part-Time', label: 'Full-Time or Part-Time' },
  { value: 'Full-Time Only', label: 'Full-Time Only' },
  { value: 'Part-Time Only', label: 'Part-Time Only' },
]

export const otherStateList = [
  { label: "Canada - Alberta", isoCode: "CA-AB", countryCode: "CA",  },
  { label: "Canada - British Columbia", isoCode: "CA-BC", countryCode: "CA" },
  { label: "Canada - Manitoba", isoCode: "CA-MB", countryCode: "CA" },
  { label: "Canada - New Brunswick", isoCode: "CA-NB", countryCode: "CA" },
  { label: "Canada - Newfoundland and Labrador", isoCode: "CA-NL", countryCode: "CA" },
  { label: "Canada - Northwest Territories", isoCode: "CA-NT", countryCode: "CA" },
  { label: "Canada - Nova Scotia", isoCode: "CA-NS", countryCode: "CA" },
  { label: "Canada - Nunavut", isoCode: "CA-NU", countryCode: "CA" },
  { label: "Canada - Ontario", isoCode: "CA-ON", countryCode: "CA" },
  { label: "Canada - Prince Edward Island", isoCode: "CA-PE", countryCode: "CA" },
  { label: "Canada - Quebec", isoCode: "CA-QC", countryCode: "CA" },
  { label: "Canada - Saskatchewan", isoCode: "CA-SK", countryCode: "CA" },
  { label: "Canada - Yukon", isoCode: "CA-YT", countryCode: "CA" },
];

export const YesNoStates = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
]

export const citizenshipFilterGroups = mirrorKeys([
  'Any Citizenship Requirement',
  'U.S. Legal Citizens & Residents',
  'U.S. Non-Citizens',
  'Canadian Legal Citizens & Residents',
  'Canadian Non-Citizens',
])

export const currentGradeLevelGroups = {
  'In High School': [
    'High School Freshman', 
    'High School Sophomore', 
    'High School Junior', 
    'High School Senior'
  ],
  'In College': [
    'Community College Freshman', 
    'Community College Freshman - Attended College Previously', 
    'Community College Sophomore', 
    'College Freshman', 
    'College Freshman - Attended College Previously', 
    'College Sophomore', 
    'College Junior', 
    'College Senior', 
    '5th Year College Undergraduate', 
    'Nth Year College Undergraduate'
  ],
  'Postgraduate': [
    'Graduate Student', 
    'Doctoral Candidate', 
    'Postgraduate Medical School', 
    'Postgraduate Law School'
  ],
}

export const seekingDegreeGroups = {
  'Professional Certification': [
    'Professional Badge', 
    'Professional Certification', 
    'Professional Micro-credential', 
    '1-year Certificate'
  ],
  'Undergraduate Degree': [
    'Associate Degree', 
    `Bachelor's Degree`,
  ],
  'Postgraduate Degree': [
    'Graduate Degree', 
    'Doctor of Medicine', 
    'Law Degree', 
    'MBA', 
    'MFA', 
    'PhD'
  ],
}
